<template>

    <div v-if=" relevantCards != null && relevantCards.length > 0" :key=" triggerTransition ">

        <div :class=" cardClasses( card ) "
            v-for=" ( card, cardKey ) in fadingList "
            :key=" cardKey " :style=" card.style "
            @click=" relevantCategories != null ? chooseCategory( card.QuickCategory ) : chooseItem( card.QuickItem ) "
            >

            <div class="inner-wrapper">

                <div class="image-wrapper">

                    <img :src=" card.Image.name != null ? imageUrl + card.Image.path + '/' + card.Image.name : '../../../img/logo.jpg' " />
                </div>
                <div class="description">

                    <h4>{{ ( relevantCategories != null ? card.QuickCategory.name : card.QuickItem.name ) || '' }}</h4>
                    <p>{{ ( relevantCategories != null ? relevantDescription( card.QuickCategory.description ) : relevantDescription( card.QuickItem.description ) ) }}</p>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="empty-menu">

        Empty Menu!
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        name: 'category',
        data: function(){

            return {

                scrollPosition : 0
            }
        },
        computed: {

            ...mapGetters({

                parentCategoryId   : 'orderMenu/parentCategoryId',
                currentCategory    : 'orderMenu/currentCategory',
                currentMenuView    : 'orderMenu/currentMenuView',
                relevantCategories : 'orderMenu/relevantCategories',
                relevantItems      : 'orderMenu/relevantItems',
                imageUrl           : 'imageUrl',
                triggerTransition  : 'triggerTransition'
            }),
            relevantCards(){ // small steps necessary to have items and categories displayed together
                // ..detailed in the steps below

                let base = [];
                if( this.relevantCategories != null ){

                    // loop through the array and surface the display sequence to the top level
                    base = base.concat( this.relevantCategories );
                }
                if( this.relevantItems != null ){

                    // loop through the array and surface the display sequence to the top level
                    base = base.concat( this.relevantItems );
                }

                // before returning, filter by display sequence
                return base;
            },
            fadingList(){

                return this.relevantCards.map( this.calculateCardStyle );
            }
        },
        methods: {

            cardClasses( card ){

                const base = [ 'outer-wrapper' ];

                if( typeof card.QuickItem != 'undefined' ){

                    base.push( this.isAvailable( card.QuickItem.available ) ? 'is-available' : 'is-not-available' );
                } else if ( typeof card.QuickCategory != 'undefined' ){

                    base.push( this.isAvailable( card.QuickCategory.status ) ? 'is-available' : 'is-not-available' );
                }
                return base.join( ' ' );
            },
            isAvailable( value ){

                // console.log( 'value: ', value );
                switch( value ){

                    case 0:
                    case "0":
                    case null:
                    case "null":

                        return false;
                        break;
                    case 1:
                    case "1":
                    case true:
                    case "true":

                        return true;
                        break;
                    default:

                        console.log( 'error invalid input to isAvailable()!' );
                        return false;
                        break;
                }
            },
            chooseCategory( QuickCategory ){

                if( this.isAvailable( QuickCategory.status ) ){

                    document.getElementById( 'menu-body' ).scrollTop = 0;
                    this.$store.dispatch( 'orderMenu/chooseCategory', QuickCategory.quickCategoryId );
                }
            },
            chooseItem( QuickItem ){

                if( this.isAvailable( QuickItem.available ) ){

                    document.getElementById( 'menu-body' ).scrollTop = 0;
                    this.$store.dispatch( 'orderMenu/chooseItem', QuickItem.quickItemId );
                }
            },
            handleScrolling(){

                const newPos = document.getElementById( 'menu-body' ).scrollTop;
                this.scrollPosition = newPos;
            },
            calculateCardStyle( card, index ) {

                const cardHeight = 150; // height + padding + margin

                const positionY = index * cardHeight;
                const deltaY    = positionY - this.scrollPosition;

                // constrain deltaY between -140 and 0
                const dY = this.clamp( deltaY, -cardHeight, 0 );

                let dissapearingValue = ( dY / cardHeight ) + 1;

                const zValue = dY / cardHeight * 50;
                const yValue = dY / cardHeight * -20;

                card.style = {

                    opacity   : dissapearingValue,
                    transform : `perspective(200px) translate3d(0,${yValue}px, ${zValue}px)`
                };
                return card;
            },
            clamp ( value, min, max ) {

                return Math.min( Math.max( min, value ), max )
            },
            relevantDescription: text => text == null ? '' : text.substring( 0, 45 ) + ( text.length > 45 ? '...' : '' )
        },
        mounted(){

            document.getElementById( 'menu-body' ).addEventListener( 'scroll', this.handleScrolling );
        },
        destroyed(){

            document.getElementById( 'menu-body' ).removeEventListener( 'scroll', this.handleScrolling );
        }
    }

</script>

<style scoped>


    .list-enter-active, .list-leave-active {

        transition: all 1s;
    }
    .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {

        opacity: 0;
        transform: translateY( 30px );
    }
    .initial-menu {

        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 1.4rem;
    }
    .outer-wrapper {

        display: flex;
        align-items: center;
        max-width: 450px;

        height: 140px;
        padding: 5px;
        margin: 0 auto;
        margin-bottom: 10px;
        font-family: Arial, Helvetica, sans-serif;
        box-shadow: 0px 3px 8px 0px rgba( 0, 0, 0, 0.5 );
        background-color: white;

        transition: background-color 0.3s ease-in;
    }
    .is-available {

    }
    .is-not-available {

        background-color: rgba( 220, 180, 180, 0.5 );
    }
    .is-not-available::after {

        content: 'unavailable';
        color: red;
        font-size: 20px;
        font-weight: bold;
        position: absolute;
        bottom: 5px;
        left: 40%;
    }
    .inner-wrapper {

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        z-index: 200;
        padding: 15px 0 15px 15px;
    }
        .inner-wrapper > .image-wrapper {

            max-width: 100px;
            max-height: 100px;
            flex: 1;
        }
            .image-wrapper > img {

                width: 100px;
                height: 100px;
                border-radius: 50%;
            }
        .inner-wrapper > .description {

            padding-left: 15px;
            flex: 2;
        }
            .description > h4 {

                color: #555;
                margin: 0;
            }
            .description > p {

                color: #777;
                padding-right: 35px;
            }
    .back-button-wrapper {

        height: 55px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
        .back-button-wrapper > button {

            margin-right: 15px;
        }

    .empty-menu {

        text-align: center;
        margin-top: 65px !important;
    }
</style>